'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SpruceClassName = require('../util/SpruceClassName');

var _SpruceClassName2 = _interopRequireDefault(_SpruceClassName);

var _set = require('unmutable/lib/pa/set');

var _set2 = _interopRequireDefault(_set);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module Components
 */

/**
 * @component
 *
 * `Text` is a Goose compliant component for general purpose text rendering.
 *
 * _**Note:** `numberFormat` & `dateFormat` will only work if the children are either strings, numbers or dates._
 *
 * @example
 * <Text>Plain Text</Text>
 * <Text modifier="hero" element="a">Hero Link</Text>
 * <Text numberFormat="0,0">{props.number}</Text>
 * <Text numberFormat="YYYY-MM-DD">{props.date}</Text>
 *
 * <Text modifier="alpha">
 *     <Text element="strong">Date: </Text>
 *     <Text dateFormat="YYYY-MM-DD">{props.date}</Text>
 * </Text>
 */

// peer dependencies
var Text = function (_React$Component) {
    (0, _inherits3.default)(Text, _React$Component);

    function Text() {
        (0, _classCallCheck3.default)(this, Text);
        return (0, _possibleConstructorReturn3.default)(this, (Text.__proto__ || (0, _getPrototypeOf2.default)(Text)).apply(this, arguments));
    }

    (0, _createClass3.default)(Text, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className,
                dateFormat = _props.dateFormat,
                TextElement = _props.element,
                htmlProps = _props.htmlProps,
                modifier = _props.modifier,
                numberFormat = _props.numberFormat,
                onClick = _props.onClick,
                peer = _props.peer,
                spruceName = _props.spruceName,
                style = _props.style,
                titleDateFormat = _props.titleDateFormat;


            var childrenToRender = children;

            if ((typeof children === "string" || typeof children === "number") && numberFormat) {
                childrenToRender = (0, _numeral2.default)(children).format(numberFormat);
            }

            // this typeof check must happen in this if, statement
            // because otherwise flow 0.54.1 cant work out that children would only be a number or a string
            if ((typeof children === "string" || typeof children === "number") && dateFormat) {
                childrenToRender = (0, _moment2.default)(new Date(children)).format(dateFormat);
            }

            // this typeof check must happen in this if, statement
            // because otherwise flow 0.54.1 cant work out that children would only be a number or a string
            if ((typeof children === "string" || typeof children === "number") && titleDateFormat) {
                htmlProps = (0, _pipeWith2.default)(htmlProps, (0, _set2.default)('title', (0, _moment2.default)(new Date(children)).format(titleDateFormat)));
            }

            return _react2.default.createElement(TextElement, (0, _extends3.default)({
                className: (0, _SpruceClassName2.default)({ name: spruceName, modifier: modifier, className: className, peer: peer }),
                style: style,
                onClick: onClick,
                children: childrenToRender
            }, htmlProps));
        }
    }]);
    return Text;
}(_react2.default.Component);

Text.defaultProps = {
    className: '',
    element: 'span',
    htmlProps: {},
    modifier: '',
    peer: '',
    spruceName: 'Text',
    style: {},
    titleDateFormat: ''
};
exports.default = Text;


//////////////////
// WEBPACK FOOTER
// ./~/stampy/lib/component/Text.js
// module id = 129
// module chunks = 35783957827783 107818501498521